import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'src/api/axiosClient/types';
import { RootState } from 'src/store';
import { CanvaState } from './types';
import { CanvaDesigns } from '../types/CanvaDesigns';

const initialState: CanvaState = {
  loading: {
    getCanvaPortalLink: false,
    connectToCanva: false,
    disconnectFromCanva: false,
    getDesigns: false,
    getDesign: false,
  },
  designs: undefined,
  query: undefined,
  error: null,
};

const canvaSlice = createSlice({
  name: 'canva',
  initialState,
  reducers: {
    setLoading: (
      state,
      action: PayloadAction<Partial<Record<keyof CanvaState['loading'], boolean>>>,
    ) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setCanvaDesings: (state, action: PayloadAction<CanvaDesigns | undefined>) => {
      state.designs = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    setCanvaQuery(state, action: PayloadAction<string | undefined>) {
      state.query = action.payload;
    },
    resetError: state => {
      state.error = initialState.error;
    },
    resetCanvaQuery: state => {
      state.query = initialState.query;
    },
    resetSlice: () => {
      initialState;
    },
  },
});

export const isCanvaLoading = (state: RootState) => state.canva.loading;

export const isCanvaError = (state: RootState) => state.canva.error;

export const getCanvaDesigns = (state: RootState) => state.canva.designs;

export const getCanvaQuery = (state: RootState) => state.canva.query;

export const { setLoading, setError, setCanvaDesings, setCanvaQuery, resetError, resetSlice } = canvaSlice.actions;

export const canvaReducer = canvaSlice.reducer;
